"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetRecipientShops;

var _functionalButton = require("@widget/functional-button");

var _reactRedux = require("react-redux");

function useGetRecipientShops() {
  var shops = (0, _reactRedux.useSelector)(_functionalButton.selectTransferRecipientShops);
  return shops || [];
}